import { render, staticRenderFns } from "./DatiGruppo.vue?vue&type=template&id=13c604e6"
import script from "./DatiGruppo.vue?vue&type=script&lang=js"
export * from "./DatiGruppo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports